import { render, staticRenderFns } from "./organization-info-form.vue?vue&type=template&id=2701fb22&scoped=true"
import script from "./organization-info-form.vue?vue&type=script&lang=js"
export * from "./organization-info-form.vue?vue&type=script&lang=js"
import style0 from "./organization-info-form.vue?vue&type=style&index=0&id=2701fb22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2701fb22",
  null
  
)

export default component.exports